import { Navigate } from "react-router-dom";
import { ErrorState, Loading } from "@/components/ui";
import { useSession } from "@/hooks/useSession";
import { useDashboard } from "@/lib/queries";
import { BestWorstCard, BoutiqueGrid } from "./Dashboard";

/** Entrée « Boutiques » : fiche directe si une seule boutique, sinon grille des cartes. */
export function BoutiquesPage() {
  const { me } = useSession();
  if (me.boutiques.length === 1) return <Navigate to={`/boutiques/${me.boutiques[0].id}`} replace />;
  return <BoutiquesList />;
}

function BoutiquesList() {
  const { isManagerView } = useSession();
  const q = useDashboard();
  return (
    <div className="flex flex-col gap-3">
      <div className="flex flex-wrap items-baseline gap-2">
        <div className="text-[15px] font-bold">{isManagerView ? "Mes boutiques" : "Toutes les boutiques"}</div>
        {q.data && <span className="text-[12px] text-muted-2">{q.data.boutiques.length} boutiques · {q.data.period.title}</span>}
      </div>
      {q.data && <BestWorstCard boutiques={q.data.boutiques} className="max-w-[420px]" />}
      {q.isLoading ? <Loading /> : q.error ? <ErrorState error={q.error} /> : q.data ? <BoutiqueGrid boutiques={q.data.boutiques} /> : null}
    </div>
  );
}
